import { useParams } from '@tanstack/react-router'
import { Offerings } from '../../components/features/offerings/Offerings'
import { AddOfferingPricePage } from './AddOfferingPricePage'
import { CreateOfferingPage } from './CreateOfferingPage'
import { EditOfferingPage } from './EditOfferingPage'
import { SingleOfferingPage } from './SingleOfferingPage'

export const OfferingsCnt = () => {
  const params = useParams({ strict: false }) as { offeringId?: string }

  if (params.offeringId && window.location.pathname.includes('/precios/nuevo')) {
    return <AddOfferingPricePage offeringId={params.offeringId} />
  }

  if (params.offeringId && window.location.pathname.includes('/modificar')) {
    return <EditOfferingPage offeringId={params.offeringId} />
  }

  if (params.offeringId) {
    return <SingleOfferingPage offeringId={params.offeringId} />
  }

  if (window.location.pathname.includes('/nuevo')) {
    return <CreateOfferingPage />
  }

  return <Offerings />
}
